var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleLogoDeviceWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6769_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4957 35.0556C23.5573 36.9554 21.4409 36.6554 19.4036 35.7555C17.2476 34.8357 15.2696 34.7957 12.995 35.7555C10.1467 36.9954 8.64345 36.6354 6.9424 35.0556C-2.71009 24.9969 -1.28595 9.67884 9.67199 9.11891C12.3423 9.25889 14.2015 10.5987 15.7641 10.7187C18.0981 10.2388 20.3332 8.85895 22.8255 9.03892C25.8122 9.27889 28.0671 10.4787 29.5506 12.6385C23.3793 16.378 24.843 24.597 30.5 26.8967C29.3726 29.8963 27.9089 32.8759 25.476 35.0756L25.4957 35.0556ZM15.5663 8.99893C15.2696 4.53949 18.8498 0.859955 22.9639 0.5C23.5376 5.65935 18.3355 9.49886 15.5663 8.99893Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6769_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 36,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogoDeviceWhite);
export default __webpack_public_path__ + "static/media/Apple-logo-device-white.57acfe45028af5a0e230a6955b830f39.svg";
export { ForwardRef as ReactComponent };